import * as React from "react";
import { LabelledData } from "../label/LabelledDataForm";
import PhoneNumber from "../commons/components/PhoneNumber";
import { getI18n } from "../commons/model/patient/Gender";
import {
  PatientAndAccountInformation,
  PatientInformation,
} from "../commons/model/patient/PatientInfo";
import { formatBirthDateAndAge } from "../commons/utils/text-rendering";
import PatientAccountInviter, { InvitationConfiguration } from "./PatientAccountInviter";
import CheckCircledFull from "../../resources/images/icons/check_circled_full.png";

export function getPatientLabelledData(
  patient: PatientInformation,
  isPatientView?: boolean,
  showLeadStatus?: boolean,
  isConvertedLead?: boolean
): LabelledData[] {
  const data = [
    {
      label: i18n["Page.PatientManagement.Profile.FirstName"],
      value: patient.firstName,
    },
    {
      label: i18n["Page.PatientManagement.Profile.LastName"],
      value: patient.lastName,
    },
    {
      label: i18n["Page.PatientManagement.Profile.BirthDate"],
      value: formatBirthDateAndAge(patient.birthDate),
    },
    {
      label: i18n["Page.PatientManagement.Profile.Email"],
      value: <span className="wrap-anywhere">{patient.email}</span>,
    },
    {
      label: i18n["Page.PatientManagement.Profile.PhoneNumber.Cell"],
      value: <PhoneNumber number={patient.phoneNumbers.cellPhoneNumber} />,
    },
    {
      label: i18n["Page.PatientManagement.Profile.ZipCode"],
      value: patient.zipCode,
    },
  ];
  if (!isPatientView && patient.externalUserId) {
    data.push({
      label: i18n["Page.PatientManagement.Profile.ExternalUserId"],
      value: patient.externalUserId,
    });
  }
  if (showLeadStatus) {
    data.push({
      label: i18n["Page.PatientManagement.Profile.Status"],
      value: (
        <span className="profile-status">
          {isConvertedLead ? (
            <>
              <img className="check-circled-full" src={CheckCircledFull} alt="check circled full" />{" "}
              &nbsp;
              {i18n["Page.PatientManagement.Profile.Status.Converted"]}
            </>
          ) : (
            i18n["Page.PatientManagement.Profile.Status.Lead"]
          )}
        </span>
      ),
    });
  }
  return data;
}

export function getFullPatientLabelledData(patient: PatientInformation): LabelledData[] {
  const patientLabelledData = getPatientLabelledData(patient);
  patientLabelledData.splice(1, 0, {
    label: i18n["Page.PatientManagement.Profile.MiddleName"],
    value: patient.middleName,
  });
  patientLabelledData.splice(3, 0, {
    label: i18n["Page.PatientManagement.Profile.PreferredName"],
    value: patient.preferredName,
  });
  patientLabelledData.splice(
    5,
    0,
    {
      label: i18n["Page.PatientManagement.Profile.Gender"],
      value: i18n[getI18n(patient.gender)],
    },
    {
      label: i18n["Page.PatientManagement.Profile.SocialSecurityNumber"],
      value: patient.socialSecurityNumber,
    }
  );
  patientLabelledData.splice(
    9,
    0,
    {
      label: i18n["Page.PatientManagement.Profile.Address"],
      value: patient.address,
    },
    {
      label: i18n["Page.PatientManagement.Profile.City"],
      value: patient.city,
    },
    {
      label: i18n["Page.PatientManagement.Profile.State"],
      value: patient.state,
    }
  );
  return patientLabelledData;
}

export function getLegalGuardianLabelledData(
  guardian: PatientAndAccountInformation,
  patientContactInfoUid: string,
  invitationConfiguration?: InvitationConfiguration
): LabelledData[] {
  const data = [
    {
      label: i18n["Page.PatientManagement.Profile.FirstName"],
      value: guardian.firstName,
    },
    {
      label: i18n["Page.PatientManagement.Profile.LastName"],
      value: guardian.lastName,
    },
    {
      label: i18n["Page.PatientManagement.Profile.Email"],
      value: <span className="wrap-anywhere">{guardian.email}</span>,
    },
    {
      label: i18n["Page.PatientManagement.Profile.PhoneNumber.Cell"],
      value: <PhoneNumber number={guardian.phoneNumbers.cellPhoneNumber} />,
    },
  ];
  if (invitationConfiguration) {
    data.push({
      label: "Account",
      value: (
        <PatientAccountInviter
          inviter={guardian}
          invitationConfiguration={invitationConfiguration}
          patientContactInfoUid={patientContactInfoUid}
        />
      ),
    });
  }
  return data;
}
